import React, { useContext } from "react";
import {
  globalDocs,
  globe,
  initiative,
  nurseSupport,
  patient,
} from "../../Assets/Images";
import Hero from "../../Components/Hero";
import { EmpdContext } from '../../Context';
import SectionBlock from "../../Components/SectionBlock";
import { INITIATIVE_PAGE_CONTENT } from "../../Consts/siteVerbiage";
import ImageTextCard from "./Components/ImageTextCard";
import { createUseStyles } from "react-jss";
import useScreenScroll from "../../Hooks/useScreenScroll";
import { RotatingLines } from 'react-loader-spinner';

const useStyles = createUseStyles({
  hero: {
    backgroundPosition: "top !important",
  },
  card: {
    marginBottom: "30px",
    "& h2": {
      fontSize: "2rem",
    },
  },
});

const useMyContext = () => {
    const context = useContext(EmpdContext)
    if( !context ) {
        throw new Error("No provider found for Context")
    }
    return context
}

const TheInitiative = () => {

  const { isLoading } = useMyContext()
  const classes = useStyles();
  useScreenScroll();

  if( isLoading ) {
    return (
		<div className='center'>
	        <RotatingLines
    	        strokeColor="#152E54"
        	    strokeWidth="3"
            	animationDuration="1.0"
	            width="48"
    	        visible={true}
        	/>
		</div>
    )
  } else {
	  return (
    	<div>
	      <Hero
    	    className={classes.hero}
        	header={INITIATIVE_PAGE_CONTENT.HERO_TITLE}
	        description={INITIATIVE_PAGE_CONTENT.HERO_DESCRIPTION}
    	    backgroundImage={initiative}
        	coverImage={globe}
	      />
    	  <SectionBlock header="Behind The Initiative">
        	<ImageTextCard
	          id={INITIATIVE_PAGE_CONTENT.TRANSFORMATIVE.ID}
    	      className={classes.card}
        	  image={patient}
	          content={
    	        <React.Fragment>
        	      <h2>Transformative</h2>
            	  <p>
	                The Crotts Global Initiative For Extramammary Paget's Disease (EMPD)
    	            was established to transform the landscape of research, care,
        	        and collaboration for a rare and often overlooked disease.
	              </p>
    	          <p>
        	        Rooted in a vision of innovation and global outreach, our
            	    initiative aims to bridge the gap between patients, clinicians,
	                and researchers, ensuring that no individual facing EMPD is
    	            without the knowledge, resources, or support they need.
        	      </p>
            	  <p>
	                The program was born out of a deep commitment to addressing
    	            unmet medical needs and advancing the understanding of this
        	        complex condition through groundbreaking research and collective
            	    expertise.
	              </p>
    	        </React.Fragment>
          	}
          />

	      <ImageTextCard
          	id={INITIATIVE_PAGE_CONTENT.GLOBAL.ID}
	        className={classes.card}
    	    flip
        	image={globalDocs}
	        content={
    	      <React.Fragment>
        	      <h2>A Global Mission</h2>
            	  <p>
	                Our mission is ambitious: to foster a global network of leading
    	            minds dedicated to improving early detection, treatment
        	        outcomes, and overall quality of life for patients with EMPD.
            	  </p>
	              <p>
    	            Through cutting-edge data collection, collaboration with
        	        scientific leaders, and patient-centered approaches, we hope to
            	    uncover new pathways for intervention and ultimately enhance the
	              	lives of those impacted worldwide.
    	          </p>
	              <p>
    	            Together, we strive to set a new standard for progress in rare
        	        disease research — one that is inclusive, innovative, and deeply
            	    compassionate.
              	</p>
            	</React.Fragment>
          	}
          />

          <ImageTextCard
          	id={INITIATIVE_PAGE_CONTENT.SUPPORT.ID}
	        image={nurseSupport}
    	    className={classes.card}
        	content={
            	<React.Fragment>
	              <h2>Generously Supported</h2>
    	          <p>
        	        This initiative is made possible through the generous support of
            	    a dedicated donor, whose personal experience with EMPD inspired
                	a mission to create lasting change for others affected by the
	                disease.
    	          </p>
        	      <p>
            	    The partnership with this donor and their family has been
                	instrumental in driving progress toward our shared goals,
	                enabling advancements in patient care, scientific innovation,
    	            and global collaboration.
        	      </p>
            	</React.Fragment>
	        }
          />
      	</SectionBlock>
      </div>
	)
  };
};

export default TheInitiative;
